import * as _ from 'lodash';
import moment from 'moment';
import Store from '../redux/store';
import { getSettingInfo } from '../tools/get-setting-info';
import { setLocalDateByDiff } from '../tools/local-moment';
import { BusinessMenu, NewSchedule } from './type.constant';

/**
 * Using this function to get specified metadata keys by `RegExp` with `Reflect.getMetadataKeys` function
 * @param target
 * @param reg
 */
export const GetMetadataKeysByRegularExpression = (target: object, reg: RegExp): any[] => {
    try {
        const keys = Reflect.getMetadataKeys(target);
        return _.filter(keys, element => reg.test(element));
    } catch (error) {
        return [];
    }
};

/**
 * Using this function to get specified metadata by `RegExp` with `Reflect.getMetadataKeys` function
 * @param target
 * @param reg
 */
export const GetMetadataByRegularExpression = (target: object, reg: RegExp): any[] => {
    try {
        const keys = Reflect.getMetadataKeys(target);
        const targetKeys = _.filter(keys, element => reg.test(element));
        return targetKeys.map(key => Reflect.getMetadata(key, target));
    } catch (error) {
        return [];
    }
};

/**
  * 新营业时间转换成当天营业时间
  * @param data
  * @returns
  */
export const scheduleTransform = (data: NewSchedule[]): BusinessMenu[] => {
    let result: BusinessMenu[] = [];
    data.filter((item) => item.value === '0').forEach((item) => {
        // 隐藏菜单
        const hideMenu = item.hide_menu;
        // 备选菜单
        const alternativeMenu = item.alternative_menu.filter((menuItem) => hideMenu.indexOf(menuItem) === -1);
        // 必选菜单
        const defaultMenu = item.default_menu.filter((menuItem) => hideMenu.indexOf(menuItem) === -1);
        result.push({
            end_time: item.end_time,
            start_time: item.start_time,
            preferred_menu: item.preferred_menu ? item.preferred_menu.toString() : '',
            alternative_menu: alternativeMenu.toString(),
            default_menu: defaultMenu.toString(),
            hide_menu: item.hide_menu ? item.hide_menu.toString() : '',
            value: item.value,
        })
    })
    return result
}

/**
 * 根据当天营业时间获取当前营业时间
 * @param data 当天营业时间
 */
export const getCurrentBusinessMenu = (data: BusinessMenu[]) => {
    const result: BusinessMenu[] = [];
    const diffTimeStamp = Store.getState().diffTimeStamp;
    const nowTime = moment(setLocalDateByDiff(diffTimeStamp));
    data.forEach((item) => {
        const startTime = moment(item.start_time, 'HH:mm');
        const endTime = moment(item.end_time, 'HH:mm');
        startTime.set({'year': nowTime.year(), 'month' : nowTime.month(), 'date': nowTime.date()})
        endTime.set({'year': nowTime.year(), 'month' : nowTime.month(), 'date': nowTime.date()})
        if (item.end_time === '24:00') {
            endTime.add(1, 'day')
        }
        if (!(
            nowTime.isBefore(startTime)
            ||
            nowTime.isAfter(endTime)
        )) {
            result.push(item)
        }

    })

    return result.length > 0 ? [result[0]] : result
}

/**
 * 是否是新营业时间
 * @returns
 */
export const isNewBusiness = (): boolean => {
    /**
      * 营业时间设置
      * 0 旧营业时间
      * 1 新营业时间
      */
    const setBusinessHour = getSettingInfo('set_business_hour', 'value');
    return setBusinessHour && setBusinessHour === 1
}

/**
 * 是否是新菜单规则
 * @returns
 */
export const isNewMenu = (): boolean => {
    /**
      * 一级菜单设置模式(0:旧的；1:新的)
      */
    const setBusinessHour = getSettingInfo('set_item_main', 'value');
    return setBusinessHour && setBusinessHour === 1
}
